<template>
    <div
        class="fixed left-0 top-0 z-[2000] flex h-full w-full items-center justify-center "
        :class="customClass"
    >
        <div
            v-if="visible"
            class="message-box-overlay absolute left-0 top-0 h-full w-full bg-black bg-opacity-50"
        ></div>
        <div v-if="visible" class="message-box-dialog z-10 flex max-w-[500px] flex-col rounded bg-white p-4" :style="{ width: dialogProps?.width }">

            <div class="flex justify-between gap-2">

                <h2 class="text-base font-semibold text-black">{{ title }}
                </h2>

                <button class="th-btn-only-icon th-btn th-btn-plain shrink-0" @click="cancel">
                    <CloseLarge/>
                </button>

            </div>

            <p class="mt-4 text-sm text-black">{{ message }}</p>

            <div class="mt-6 flex justify-end gap-2">
                <button
                    type="button"
                    class="th-btn th-btn-secondary"
                    @click="cancel"
                >
                    {{ cancelButtonText }}
                </button>
                <button
                    type="button"
                    class="th-btn th-btn-warning"
                    @click="confirm"
                >
                    {{ confirmButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import CloseLarge from './CloseLarge.vue';

const props = defineProps<{
    message: string;
    title: string;
    confirmButtonText: string;
    cancelButtonText: string;
    customClass?: string;
    dialogProps?: {
        width?: string;
    };
    callback?: (confirm: boolean) => void;
    cancelCallback?: () => void;
}>()

const visible = ref(true);

function close() {
    visible.value = false;
}

function cancel() {
    if (props.cancelCallback) {
        props.cancelCallback();
    }
    close();
}

function confirm() {
    if (props.callback) {
        props.callback(true);
    }
    close();
}

</script>
